<template>
  <div class="small-content">
    <ContentInfo
      :conclusionLevel="diseaseItem.conclusion"
      :text="diseaseInfo.dis_desc"
    ></ContentInfo>
    <div class="content-main">
      <van-tabs v-model="activeTab">
        <van-tab>
          <div slot="title">风险评估</div>
          <ContentRisk :data="diseaseItem"></ContentRisk>
        </van-tab>
        <van-tab>
          <div slot="title">基因列表</div>
          <ContentGene :list="diseaseGene"></ContentGene>
        </van-tab>
        <!-- <van-tab>
          <div slot="title">参考文献</div>
          <ContentReference :list="reference"></ContentReference>
        </van-tab> -->
      </van-tabs>
    </div>
    <div class="content-main">
      <ContentInfo
        v-if="diseaseInfo.dis_factor"
        icon="iconbingli"
        color="orange"
        title="致病因素"
        :text="diseaseInfo.dis_factor"
      ></ContentInfo>
      <ContentInfo
        v-if="diseaseInfo.dis_symptom"
        icon="iconhebingxingzhuang"
        color="pink"
        title="早期症状"
        :text="diseaseInfo.dis_symptom"
      ></ContentInfo>
      <ContentInfo
        v-if="diseaseInfo.dis_screening"
        icon="iconjibingxinxihuizong"
        color="blue"
        title="体检建议"
        :text="diseaseInfo.dis_screening"
      ></ContentInfo>
      <ContentInfo
        v-if="diseaseInfo.dis_advices"
        icon="iconleshenghuo"
        color="gray"
        title="生活建议"
        :text="diseaseInfo.dis_advices"
      ></ContentInfo>
    </div>
  </div>
</template>

<script>
import ContentRisk from "./content/ContentRisk.vue";
import ContentGene from "./content/ContentGene.vue";
// import ContentReference from "./content/ContentReference.vue";
import ContentInfo from "./content/ContentInfo.vue";
export default {
  components: { ContentRisk, ContentGene, ContentInfo },
  props: {
    diseaseItem: {
      // 单项疾病
      type: Object,
      default: () => {},
    },
    diseaseInfo: {
      // 疾病信息
      type: Object,
      default: () => {},
    },
    diseaseGene: {
      // 解读基因列表
      type: Array,
      default: () => [],
    },
    reference: {
      // 参考文献
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeTab: "", // tabs 切换
    };
  },
};
</script>

<style lang="scss">
.small-content {
  .content-main {
    background-color: #fff;
    margin-top: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/smallGlobal/GlobalContent.vue